<template>
  <ul class="grid grid-cols-1 gap-6 lg:gap-10 2xl:gap-86px sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
    <li class="col-span-1 bg-white rounded-large ring ring-white" v-for="animal in animalTypes"
      :key="animal.type" :class="[
        animal.isActive ? 'ring-brand-dark shadow-animalType' : ''
      ]" @click="toggle(animal)">
      <!-- TODO: remove animal.disabled in click event, when logic will be done -->
      <div class="text-center pt-14 p-8 relative">
        <img class="w-28 h-28 mx-auto" :src="getSelectedProduct === 'proact' ? animal.imgSrcProact : animal.imgSrc"
          :alt="animal.name">
        <h3 class="mt-11 text-xl xl:text-2xl font-medium">
          {{ animal.name }}
          <span v-if="animal.tooltip" class="icon w-4 tooltip-block" v-html="icons.note" v-tooltip="animal.tooltip">
          </span>
        </h3>
        <div v-if="animal.items"
          class="group-hover:border-brand-100 flex-col absolute inset-0 -top-[2px] -bottom-[2px] py-8 bg-brand-semiMedium text-white text-xl font-semibold rounded-large border-2 border-green-light justify-evenly"
          :class="animal.items && animal.id === activeAnimalTileId ? 'flex border-brand-100' : 'hidden group-hover:flex'">
          <div v-for="item in animal.items" :key="item.id" @click.stop="toggle(item)" class="px-6 py-3 -mx-1 text-lg"
            :class="item.id === activeAnimalId ? ' bg-green-600' : 'hover:bg-green-600'">
            {{ item.name }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import {mapMutations, mapState, mapGetters, mapActions} from 'vuex';

export default {
  name: 'AnimalType',

  created() {
    this.resetAnimalState()
  },

  data: () => ({
    activeAnimalTileId: 0,
    activeAnimalId: 0,
  }),

  methods: {
    ...mapMutations({
      setActiveAnimalType: 'animalType/setActiveAnimalType',
      setResultMatrix: 'result/setResultMatrix',
      setActiveDiet: 'feed/setActiveDiet'
    }),

    toggle(animal) {
      if (animal.id !== this.$store.getters['feed/getActiveDiet'].animal_id) {
        this.setActiveDiet({})
      }

      if (animal.parent_id) {
        this.activeAnimalTileId = this.animalTypes.find(el => el.id === animal.parent_id).id;
      } else this.activeAnimalTileId = animal.id;

      this.activeAnimalId = animal.id;

      this.setActiveAnimalType(animal)
      this.setResultMatrix({})
    },

    ...mapActions({
      resetAnimalState: 'animalType/resetState'
    })
  },

  computed: {
    ...mapState('animalType', {
      animalTypes: state => state.animalTypes,
    }),

    ...mapGetters({
      getSelectedProduct: 'productSelect/getSelectedProduct'
    }),
  }
};
</script>

<style scoped>
>>> .tooltip-block svg {
  width: 16px;
  height: 16px;
}
</style>
